import React, { useState } from "react";
import { Helmet } from "react-helmet-async";
import emailjs from "emailjs-com";

const Iletisim = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });

  const [status, setStatus] = useState("");

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus("Gönderiliyor...");

    try {
      await emailjs.send(
        "hacialiweb", // Your EmailJS service ID
        "template_vvyvpli", // Your EmailJS template ID
        formData,
        "bGhtkhENRI184jo1r" // Your EmailJS user ID
      );
      setStatus("E-posta başarıyla gönderildi!");
      setFormData({ name: "", email: "", subject: "", message: "" });
    } catch (error) {
      console.error("E-posta gönderim hatası:", error);
      setStatus("E-posta gönderilirken hata oluştu.");
    }
  };

  return (
    <>
      <Helmet>
        <title>Bana Ulaşın | Hacı Ali Kara</title>
        <link rel="canonical" href="https://www.hacialikara.com/iletisim" />
        <meta
          name="description"
          content="Her türlü soru ve iş birliği için benimle iletişime geçebilirsiniz. Kocaeli, Yeşilova'da hizmet veriyorum."
        />
        <meta
          name="keywords"
          content="İletişim, Hacı Ali Kara, Eğitim, Kocaeli, Yeşilova"
        />
        <meta property="og:title" content="Bana Ulaşın | Hacı Ali Kara" />
        <meta
          property="og:description"
          content="Her türlü soru ve iş birliği için benimle iletişime geçebilirsiniz. Kocaeli, Yeşilova'da hizmet veriyorum."
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.hacialikara.com/iletisim" />
      </Helmet>

      <div className="contact section light-background">
        <div className="container" data-aos="fade-up" data-aos-delay="100">
          <div className="row g-5">
            <div className="col-lg-6">
              <div className="content" data-aos="fade-up" data-aos-delay="200">
                <h2 className="display-5 mb-4">Bana Ulaşın</h2>
                <p className="lead mb-4">Her türlü soru ve iş birliği için benimle iletişime geçebilirsiniz.</p>

                <div className="contact-info mt-5">
                  <div className="info-item d-flex mb-3">
                    <i className="bi bi-envelope-at me-3"></i>
                    <span>dev@hacialikara.com</span>
            
                  </div>
                  <div className="info-item d-flex mb-3">
                    <i className="bi bi-telephone me-3"></i>
                    <span>0505 106 41 15</span>
                  </div>
                  <div className="info-item d-flex mb-4">
                    <i className="bi bi-geo-alt me-3"></i>
                    <span>Kocaeli, Yeşilova</span>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-6">
              <div className="contact-form card" data-aos="fade-up" data-aos-delay="300">
                <div className="card-body p-4 p-lg-5">
                  <form onSubmit={handleSubmit}>
                    <div className="row gy-4">
                      <div className="col-12">
                        <input
                          type="text"
                          name="name"
                          className="form-control"
                          placeholder="Adınız"
                          value={formData.name}
                          onChange={handleChange}
                          required
                        />
                      </div>
                      <div className="col-12">
                        <input
                          type="email"
                          name="email"
                          className="form-control"
                          placeholder="E-posta Adresiniz"
                          value={formData.email}
                          onChange={handleChange}
                          required
                        />
                      </div>
                      <div className="col-12">
                        <input
                          type="text"
                          name="subject"
                          className="form-control"
                          placeholder="Konu"
                          value={formData.subject}
                          onChange={handleChange}
                          required
                        />
                      </div>
                      <div className="col-12">
                        <textarea
                          name="message"
                          className="form-control"
                          rows="6"
                          placeholder="Mesajınız"
                          value={formData.message}
                          onChange={handleChange}
                          required
                        ></textarea>
                      </div>
                      <div className="col-12 text-center">
                        <button type="submit" className="btn btn-submit w-100">Gönder</button>
                        {status && <p className="mt-3">{status}</p>}
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Iletisim;